import { IBulkQuoteOfferingReqSchema, IOfferingRes } from '@monetize/types/app';
import { Control, Controller, FormState } from 'react-hook-form';
import { MFormField, MStack } from '../../../../../components/Monetize';
import { MCustomMultiSelect } from '../../../../../components/Monetize/MCustomSelect/MCustomMultiSelect';
import {
  ImportQuoteOfferingsModal,
  ImportQuoteOfferingsModalProps,
} from '../ImportQuoteOfferingsModal';

interface BulkOfferingSelectionProps extends ImportQuoteOfferingsModalProps {
  errors: FormState<IBulkQuoteOfferingReqSchema>['errors'];
  control: Control<IBulkQuoteOfferingReqSchema>;
  items: IOfferingRes[];
  displayImportOffering: boolean;
  disabled?: boolean;
  onApply: () => void;
}

export const BulkOfferingSelection = ({
  displayImportOffering,
  onImported,
  quote,
  errors,
  control,
  items,
  disabled,
  onApply,
}: BulkOfferingSelectionProps) => {
  return (
    <MStack direction={'row'} alignItems={'end'}>
      <MFormField error={errors.offerings} isRequired isDisabled={disabled}>
        <Controller
          control={control}
          name={'offerings'}
          render={({ field: { onChange, value, ...rest } }) => {
            return (
              <MCustomMultiSelect
                isDisabled={disabled}
                value={value}
                onChange={(val) => {
                  onChange(val);
                }}
                onAdd={(val, allItems) => {
                  onChange(allItems);
                }}
                onRemove={(val, allItems) => {
                  onChange(allItems);
                }}
                closeButtonText={`Review rates (${value?.length ?? 0})`}
                onCloseButtonClick={() => {
                  onChange(value);
                  onApply();
                }}
                items={items}
                itemTitle="name"
                itemValue="id"
                multiple
                checkboxDisplay
                showSelectAll
                returnItem
                rightLabel
                showQueryInput
              />
            );
          }}
        ></Controller>
      </MFormField>
      {displayImportOffering && (
        <ImportQuoteOfferingsModal quote={quote} onImported={onImported} />
      )}
    </MStack>
  );
};
